import { all, call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'redux-first-history';

import { Action, Resource } from '@topconagriculture/permissions';
import { checkPermissions } from '@topconagriculture/casbin-react';

import { accessDeniedRoutesPaths } from '../../../routes/AccountManagement/AccessDenied/AccessDeniedRoutes';
import { boostrapApp } from '../bootstrap/bootstrap.actions';

export function* canAccessFeedSaga() {
  const canAccessFeed = yield call(checkPermissions, { resource: Resource.FEED, action: Action.LAUNCH });
  if (!canAccessFeed) {
    yield put(push(accessDeniedRoutesPaths.accessDeniedRoot));
  }
}

export function* watchAuthorizationSaga() {
  yield all([yield takeLatest(boostrapApp.done, canAccessFeedSaga)]);
}
